import { render } from "./NewsListItem.vue?vue&type=template&id=11371d4b&scoped=true"
import script from "./NewsListItem.vue?vue&type=script&lang=js"
export * from "./NewsListItem.vue?vue&type=script&lang=js"

import "./NewsListItem.vue?vue&type=style&index=0&id=11371d4b&lang=scss&scoped=true"

import exportComponent from "/var/www/html/app_player/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11371d4b"]])

export default __exports__